import { Card } from '@/components';
import { icHandshake } from '@/components/GenericsTournaments/Icons/';
import { useIsDesktop } from '@/hooks/useIsDesktop';

export const InfoContentMasInfoDesafio = () => {
  const { isDesktop } = useIsDesktop();
  return (
    <>
      {isDesktop ? (
        <div className="text-left overflow-y-auto scrollbar-hide max-h-[80vh] [&::-webkit-scrollbar]:hidden [-ms-overflow-style:'none'] [scrollbar-width:'none']">
          <h6 className="lg:text-center lg:text-base text-sm font-bold text-gdt-blue-header flex lg:items-center max-sm:max-w-[250px]">
            <figure className="min-w-8">
              <img
                alt="Icono de moneda"
                className="h-[35px]"
                src={icHandshake}
              />
            </figure>
            <span>¿Qué son los Desafíos 1 a 1 y cómo participar?</span>
          </h6>
          <p className="my-2">
            Con tu equipo de Primera, podés
            <span className="font-semibold">
              {`  desafiar todas las fechas a tus
              amigos a un mano a mano. `}
            </span>
            Podrás desafiar a cuantos amigos quieras y lo podrás hacer todas las
            fechas
            <br />
            <br />
            Si ganás 15 desafíos podrás ganar una medalla. Solamente podrás
            ganar 5 medallas por desafíos ganados.
          </p>
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          <Card className="!px-6 !pb-8 !w-auto !pt-4 bg-white">
            <h6 className="lg:text-center lg:text-base text-sm font-bold text-gdt-blue-header flex lg:items-center max-sm:max-w-[250px]">
              <figure className="min-w-8">
                <img
                  alt="Icono de interrogacion"
                  className="h-[35px]"
                  src={icHandshake}
                />
              </figure>
              <span>¿Qué son los Desafíos 1 a 1 y cómo participar?</span>
            </h6>
            <p className="my-2">
              <span className="font-semibold">
                Con tu equipo de Primera, podés desafiar todas las fechas a tus
                amigos a un mano a mano. Podrás desafiar a cuantos amigos
                quieras y lo podrás hacer todas las fechas
              </span>
              <br />
              <br />
              Si ganás 15 desafíos podrás ganar una medalla. Solamente podrás
              ganar 5 medallas por desafíos ganados.
            </p>
          </Card>
        </div>
      )}
    </>
  );
};
